import classNames from 'classnames';
import React from 'react';
import * as styles from './Caret.module.scss';
import type { SVGIconSize } from './SVGIcon';
import SVGIcon from './SVGIcon';
import caretIcon from '../icons/non-prefilled/16x16/caret.svg';

export type CaretDirection = 'up' | 'down' | 'left' | 'right';

interface CaretProps {
  direction?: CaretDirection;
  inline?: boolean;
  block?: boolean;
  size?: SVGIconSize;
}

const Caret = ({
  direction = 'down',
  inline = false,
  block = false,
  size = 8,
}: CaretProps) => {
  return (
    <SVGIcon
      className={classNames(styles.caret, styles[direction], {
        [styles.block]: block,
      })}
      inline={inline}
      size={size}
    >
      {caretIcon}
    </SVGIcon>
  );
};

export default Caret;
